export interface BillStatusType {
  title: string;
  code: number;
  color: string;
}

export const BillStatus: { [key: string]: BillStatusType } = {
  ALL: {
    title: "全部",
    code: 100,
    color: "#808080",
  },
  PENDING: {
    title: "待支付",
    code: 0,
    color: "#ff9800",
  },
  PAID: {
    title: "已支付",
    code: 1,
    color: "#2196f3",
  },
  LANDED: {
    title: "已到账",
    code: 2,
    color: "#4caf50",
  },
  REFUNDED: {
    title: "已退款（到账前）",
    code: -1,
    color: "#9e9e9e",
  },
  RECALLED: {
    title: "已退款（到账后）",
    code: -2,
    color: "#607d8b",
  },
  CANCELED: {
    title: "放弃支付",
    code: -100,
    color: "#f44336",
  },
};

export const getBillStatusTitle = (code: number): string => {
  const status = Object.values(BillStatus).find((item) => item.code === code);
  return status?.title || "未知状态";
};

export const getBillStatusColor = (code: number): string => {
  const status = Object.values(BillStatus).find((item) => item.code === code);
  return status?.color || "#808080";
};

export const getBillStatusChoices = (): Array<{ id: number; name: string }> => {
  return Object.values(BillStatus).map((item) => ({
    id: item.code,
    name: item.title,
  }));
};

export default BillStatus;
